import { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from 'mobily-ui-library/lib';
import { GlobalContext } from '../../../context/GlobalContext';

import ClaimCardButton from '../ClaimCardButton/ClaimCardButton';
import HeaderNavigation from '../HeaderNavigation/HeaderNavigation';

import { installmentCustomerEligibility } from '../../../api/api';
import ErrorModal from '../../ErrorModal/ErrorModal';

import './DeviceClaim.scss';

interface Props {
    handleHeaderCancel: () => void;
}


function DeviceClaim({ handleHeaderCancel }: Props) {
    const { state, dispatch }: any = useContext(GlobalContext);
    const { rtl, promotionData, raqiPromotion, wajidPromotion, deviceFlow, packageEligibility, customerAccount, msisdn, scData, productData } = state;

    const [notEligible, setNotEligible] = useState(false);
    const installmentPlans = packageEligibility?.deviceInstallmentPromotions ? packageEligibility?.deviceInstallmentPromotions : [];
    const [installmentErrorTitle, setInstallmentErrorTitle] = useState('');
    const [installmentErrorBody, setInstallmentErrorBody] = useState('');
    const [isInstallmentError, SetIsInstallmentError] = useState(false);
    const [transId, setTransId] = useState('');
    const [errorCode, setErrorCode] = useState('');
    const { t } = useTranslation();
    const [customerNotEligible, setCustomerNotEligible] = useState(false);
    const [customerNotEligibleErrorTitle, setCustomerNotEligibleErrorTitle] = useState('');
    const [customerNotEligibleErrorBody, setCustomerNotEligibleErrorBody] = useState('');
    const installmentErrorCodes = ['26215', '2118', '1112', '26216', '1111', '26217', '26218',
        '26219', '26220', '26224', '26238', '26721', '26722', '26723', '26724', '9010', '26727'];
    const handleClaim = (value: string) => {
        const appliedPromo = promotionData?.filter((item: any) => {
            return item.name === value;
        })[0];
        const promoObj = appliedPromo?.metaExtension?.dataSet[0]?.genericData?.valueSet;
        const promoTypeCode = promoObj?.promoTypeCode ? promoObj?.promoTypeCode : "";
        const promoTypeValueEn = promoObj?.promoTypeValueEN ? promoObj?.promoTypeValueEN : "";
        const promoTypeValueAr = promoObj?.promoTypeValueAR ? promoObj?.promoTypeValueAR : "";
        const promoTypeValue = rtl ? promoTypeValueAr : promoTypeValueEn;
        const promoPeriod = promoObj?.commitmentPeriod;
        const promoAmount = appliedPromo?.action[0]?.actionValue;
        dispatch({ type: 'SUB_PAGE_TO_DISPLAY', payload: { subPageToDisplay: "deviceTermsNCondition" } })
        dispatch({ type: 'PROMOTION_APPLIED', payload: { promotionApplied: appliedPromo, promoTypeCode: promoTypeCode, promoTypeValue: promoTypeValue, promoPeriod, promoAmount } })
    }

    const handleInstallmentPopup = () => {
        dispatch({ type: "LOADER", payload: { loading: false } });
        document.body.style.overflow = 'auto';
        SetIsInstallmentError(false);
        dispatch({ type: 'SUB_PAGE_TO_DISPLAY', payload: { subPageToDisplay: "deviceLogin" } })
    }

    const handleInstallmentClaim = (value: string) => {
        dispatch({ type: "LOADER", payload: { loading: true } });
        const whitelistFlag = packageEligibility?.whitelistFlag ? packageEligibility?.whitelistFlag : "";
        const appliedInstallment = installmentPlans?.filter((item: any) => {
            return item.PromotionTechnicalName === value;
        })[0];

        dispatch({ type: 'APPLIED_INSTALLMENT', payload: { appliedInstallment: appliedInstallment } })
        let monthlyAmount = appliedInstallment?.MonthlyCommitmentAmt ? appliedInstallment?.MonthlyCommitmentAmt : "";
        let promotionTechnicalName = appliedInstallment?.PromotionTechnicalName ?? '';
        installmentCustomerEligibilityAPI(whitelistFlag, monthlyAmount, promotionTechnicalName);
    }

    const installmentCustomerEligibilityAPI = (whitelistFlag: string, monthlyAmount: string, promotionTechnicalName: string) => {
        const sanNum = customerAccount?.ServiceAccountNumber ? customerAccount?.ServiceAccountNumber : "";
        const shoppingCartId = scData?.id
        const productOfferId = productData?.id
        const installmentType = packageEligibility?.deviceInstallmentPromotions?.[0]?.InstallmentType
        const reqInst = {
            msisdn: msisdn.replace(/^0/, "966"),
            san: sanNum,
            whitelistFlagVal: whitelistFlag,
            monthlyAmount: monthlyAmount,
            shoppingCartId: shoppingCartId,
            productOfferId: productOfferId,
            installmentType: installmentType,
            promotionTechnicalName
        }
        installmentCustomerEligibility(reqInst)
            .then((res: any) => {
                const sourceCode = res.data?.status?.sourceCode;
                setInstallmentErrorTitle(t(`${res.data?.status?.sourceCode}_title`))
                setInstallmentErrorBody(t(`${res.data?.status?.sourceCode}_body`))

                if (res.status === 200 && res.data) {
                    if (res.data?.status?.code === "CEM_0000") {
                        if (res.data?.eligibleForInstallment === "Yes") {
                            dispatch({ type: "LOADER", payload: { loading: false } });
                            dispatch({ type: 'SUB_PAGE_TO_DISPLAY', payload: { subPageToDisplay: "deviceTermsNCondition" } })
                        } else {
                            dispatch({ type: "LOADER", payload: { loading: false } });
                            const errCode = res?.status;
                            setTransId(res?.config?.headers['X-Transaction-Id']);
                            setErrorCode(errCode);
                            setNotEligible(true);
                        }
                    } else if (res.data?.status?.code === "CEM_70001") {
                        dispatch({ type: "LOADER", payload: { loading: false } });
                        setCustomerNotEligible(true)
                        setCustomerNotEligibleErrorTitle(t('customerNotEligibleErrorTitle'))
                        setCustomerNotEligibleErrorBody(t('customerNotEligibleErrorBoby'))
                    } else if (res.data?.status?.code === "CEM_26500") {
                        dispatch({ type: "LOADER", payload: { loading: false } });
                        setCustomerNotEligible(true)
                        setCustomerNotEligibleErrorTitle(t('MNPcustomerNotEligibleErrorTitle'))
                        setCustomerNotEligibleErrorBody('')
                    } else {
                        dispatch({ type: "LOADER", payload: { loading: false } });
                        if (installmentErrorCodes.includes(sourceCode)) {
                            SetIsInstallmentError(true)
                            const errCode = sourceCode;
                            setTransId(res?.config?.headers['X-Transaction-Id']);
                            setErrorCode(errCode);
                            setInstallmentErrorBody(`${t(`${sourceCode}_body`)}`);
                        } else {
                            SetIsInstallmentError(true)
                            const errCode = res?.status;
                            setTransId(res?.config?.headers['X-Transaction-Id']);
                            setErrorCode(errCode);
                            setInstallmentErrorTitle(t(`26239_title`))
                            setInstallmentErrorBody(t(`26239_body`));
                        }
                    }
                } else {
                    dispatch({ type: "LOADER", payload: { loading: false } });

                    SetIsInstallmentError(true)
                    const errCode = res?.status;
                    setTransId(res?.config?.headers['X-Transaction-Id']);
                    setErrorCode(errCode);
                    setInstallmentErrorTitle(t(`26239_title`))
                    setInstallmentErrorBody(t(`26239_body`));

                }
            }).catch(() => {
                dispatch({ type: "LOADER", payload: { loading: false } });
                SetIsInstallmentError(true)
                setInstallmentErrorTitle(t(`26239_title`))
                setInstallmentErrorBody(t(`26239_body`));
            })
    }

    const handleNotEliglible = () => {
        setNotEligible(false);
        document.body.style.overflow = 'auto';
        dispatch({ type: 'SUB_PAGE_TO_DISPLAY', payload: { subPageToDisplay: "deviceLogin" } })
    }

    return (
        <>
            <div className='TransactionID' id="TransactionID" style={{ display: 'none' }}>{transId}</div>
            <div className='ErrorCode' id="ErrorCode" style={{ display: 'none' }}>{errorCode}</div>
            <HeaderNavigation
                rtl={rtl}
                percent={75}
                showBackArrow={false}
                handleHeaderCancel={handleHeaderCancel}
            />
            <div className='Subsidy__Plans'>
                <div className='SCP__headerText'>
                    <Typography rtl={rtl} id="lineType-heading" className='SCP__heading'>{deviceFlow === 'subsidy' ? t('Available_subsidy') : t('your_availble_insatallments')}</Typography>
                    <Typography rtl={rtl} id="lineType-Subheading" className='SCP__subHeading'>{deviceFlow === 'subsidy' ? t('Eligible_plans_subsidy') : t('congratulations_installment_plan_eligible')}</Typography>
                    <Typography rtl={rtl} id="lineType-Subheading" className='SCP__subHeading'>{t('Option_Continue')}</Typography>
                </div>

                {deviceFlow === 'subsidy' ? promotionData?.length > 0 && (
                    promotionData
                        .sort((a: any, b: any) => a.metaExtension.dataSet[0].genericData.valueSet.sequence > b.metaExtension.dataSet[0].genericData.valueSet.sequence ? 1 : -1)
                        .map((item: any) => {
                            const promo = item.metaExtension.dataSet[0].genericData.valueSet
                            const commitmentPeriod = promo.commitmentPeriod;
                            const amount = item.action[0].actionValue;

                            if (raqiPromotion.length > 0) {
                                return (
                                    <ClaimCardButton
                                        rtl={rtl}
                                        key={item.id}
                                        amount={amount}
                                        handleClaim={handleClaim}
                                        commitmentPeriod={commitmentPeriod}
                                        claimPromo={item.name}
                                        claimButtonEnable={raqiPromotion.includes(item.name)}
                                    />
                                )
                            } else {
                                return wajidPromotion.map((wj: any) => {
                                    if (promo.promoName.includes(wj)) {
                                        return (
                                            <ClaimCardButton
                                                rtl={rtl}
                                                key={item.id}
                                                amount={amount}
                                                handleClaim={handleClaim}
                                                commitmentPeriod={commitmentPeriod}
                                                claimPromo={item.name}
                                                claimButtonEnable={true}
                                            />
                                        )
                                    }
                                })
                            }
                        })
                ) : (
                    installmentPlans.map((item: any, key: number) => {
                        return (
                            <ClaimCardButton
                                rtl={rtl}
                                key={key}
                                amount={item?.MonthlyCommitmentAmt}
                                handleClaim={handleInstallmentClaim}
                                commitmentPeriod={item?.PromotionCommitmentPeriod}
                                totalAmount={item?.TotalDeviceInstallmentAmount}
                                claimPromo={item?.PromotionTechnicalName}
                                claimButtonEnable={true}
                            />
                        )
                    })

                )}
                {notEligible && (
                    <ErrorModal
                        id={'not-a-mobily-number'}
                        rtl={rtl}
                        title={t('installment_plan_not_eligible')}
                        description={t('installment_Number_not_eligible')}
                        firstButtonText={t('Got_it')}
                        modalFirstButtonClick={handleNotEliglible}
                    />
                )}
                {isInstallmentError && (
                    <ErrorModal
                        id={'not-a-mobily-number'}
                        rtl={rtl}
                        title={installmentErrorTitle}
                        description={installmentErrorBody}
                        firstButtonText={t('Got_it')}
                        modalFirstButtonClick={handleInstallmentPopup}
                    />
                )}
                {customerNotEligible && (
                    <ErrorModal
                        id={'not-a-mobily-number'}
                        rtl={rtl}
                        title={customerNotEligibleErrorTitle}
                        description={customerNotEligibleErrorBody}
                        firstButtonText={t('Got_it')}
                        modalFirstButtonClick={handleNotEliglible}
                    />
                )}
            </div>
        </>
    )
}

export default DeviceClaim